import luxinLanguages from "@/statics/language.js";

luxinLanguages.dar = {
  title: "دری",
  short: "dar",
  isRTL: true,
  NODE2_INPUT1_NAME: "ورودی ۱",
  NODE2_INPUT2_NAME: "ورودی ۲",
  NODE2_OUTPUT1_NAME: "خروجی ۱",
  NODE2_OUTPUT2_NAME: "خروجی ۲",
  NODE3_INPUT1_NAME: "ورودی ۱",
  NODE3_OUTPUT1_NAME: "خروجی ۱",
  NODE4_INPUT1_NAME: "ورودی ۱",
  NODE4_INPUT2_NAME: "ورودی ۲",
  NODE4_OUTPUT1_NAME: "خروجی ۱",
  NODE5_INPUT1_NAME: "ورودی ۱",
  NODE5_OUTPUT1_NAME: "خروجی ۱",
  NODE6_INPUT1_NAME: "دما",
  NODE6_INPUT2_NAME: "رطوبت",
  Hub_Owner: "مدیر",
  Hub_User: "کاربر",
  Common_internetError: "لطفا اتصال اینترنت خود را چک کنید.",
  Devices_addNewDevice: "افزودن دستگاه",
  BottomNav_dashboard: "صفحه اصلی",
  BottomNav_devices: "دستگاه ها",
  BottomNav_settings: "تنظیمات",
  Devices_Hub_Priviledge: "سطح دسترسی",
  Devices_Hub_IP: "آدرس شبکه",
  Devices_Hub_accessOwner: "مدیر",
  Devices_Hub_accessNormal: "کاربر",
  Devices_noHubs: "هیچ هابی پیدا نشد!",
  Devices_noNodes: "دستگاهی برای این هاب پیدا نشد!",
  Device_serachPlaceHolder: "جستجو...",
  Devices_searchNotFound: "هیچ موردی پیدا نشد.",
  LanguageSelect_selectLanguage: "انتخاب زبان",
  LanguageSelect_submitButton: "تایید",
  LoginRegister_title: "ورود",
  LoginRegister_text: "لطفا شماره موبایل خود را وارد نمایید.",
  LoginRegister_button: "ارسال کد",
  LoginRegister_placeHolder: "شماره موبایل",
  LoginRegister_back: "بازگشت",
  LoginRegister_inputError: "شماره موبایل صحیح نمی باشد.",
  LoginRegister_serverResponseFail: "درخواست شما انجام نشد. لطفا شماره موبایل خود را چک کرده و مجددا تلاش نمایید.",
  LoginConfirmationCode_title: "کد تایید",
  LoginConfirmationCode_text: "لطفا کدی که به موبایل شما ارسال شده را وارد نمایید.",
  LoginConfirmationCode_failMessage: "کد وارد شده اشتباه است!",
  LoginConfirmationCode_retry: "ارسال مجدد",
  LuxinIntro_Next: "بعدی",
  LuxinIntro_Finish: "پایان",
  IntroSlide1_title: "به لکسا خوش آمدید",
  IntroSlide1_text: "با این اپ به راحتی می توانید خانه هوشمند خود را کنترل کنید.",
  IntroSlide2_title: "اینترنت اشیا",
  IntroSlide2_text: "شما می توانید در هر زمانی و از هر نقطه دنیا به خانه هوشمند خود متصل باشید.",
  IntroSlide3_title: "هاب لکسا",
  IntroSlide3_text: "هاب لکسا مغز متفکر خانه هوشمند شماست. در اولین قدم باید به یک هاب وصل شوید.",
  IntroSlide4_title: "دسترسی کاربران",
  IntroSlide4_text: "اگر کاربر دیگری هاب شما را راه انداخته است، از آنها بخواهید به شما دسترسی دهند.",
  AddDevice_title: "اضافه کردن دستگاه",
  AddDevice_text: "اگر اولین فردی نیستید که این هاب را تنظیم می کنید،‌ گزینه دوم را انتخاب کنید.",
  AddDevice_button: "اضافه کردن دستگاه جدید",
  AddDevice_button2: "اتصال به دستگاه تنظیم شده",
  AddNewDevice_title: "افزودن دستگاه جدید",
  AddNewDevice_text: "در این مرحله به کد QR چاپ شده بر روی محصول احتیاج دارید.",
  AddNewDevice_button: "اسکن با دوربین",
  AddNewDevice_button2: "انتخاب عکس",
  AddNewDeviceScanQR_title: "حالت اسکن با دوربین",
  AddNewDeviceScanQR_text: "سعی کنید کد QR را داخل کادر بالا بیندازید. در ابتدا باید دسترسی اپ به دوربین موبایل خود را فعال کنید.",
  AddNewDeviceScanQR_button: "اسکن مجدد",
  AddNewDeviceScanQR_loading: "لطفا صبر کنید...",
  AddNewDeviceScanQR_error: "QR نادرست است...",
  AddNewDeviceScanQR_NotAllowedError: "لطفا دسترسی این اپ به دوربین را فعال کنید.",
  AddNewDeviceScanQR_NotFoundError: "خطا در پیدا کردن دوربین",
  AddNewDeviceScanQR_NotSupportedError: "خطا در پشتیبانی از دوربین",
  AddNewDeviceScanQR_NotReadableError: "خطا در خواندن دوربین",
  AddNewDeviceScanQR_OverconstrainedError: "خطا در مشخصات تصویر",
  AddNewDeviceScanQR_StreamApiNotSupportedError: "خطا در پشتیبانی از جریان تصویر",
  AddNewDeviceUploadQR_button: "انتخاب تصویر",
  AddNewDeviceUploadQR_title: "انتخاب تصویر کد QR",
  AddNewDeviceUploadQR_text: "لطفا یک تصویر حاوی کد QR محصول را انتخاب کنید.",
  AddNewDeviceUploadQR_alert: "تصویر انتخاب شده حاوی کد QR صحیح نمی باشد. لطفا مجددا تلاش نمایید.",
  AddDeviceNoHub_title: "اخطار",
  AddDeviceNoHub_text: "هیچ هابی در سیستم شما نصب نشده است. لطفا ابتدا یک هاب لکسا اضافه کنید.",
  AddNewDeviceDuplicated_title: "اخطار",
  AddNewDeviceDuplicated_text: "این دستگاه قبلا ثبت شده است.",
  AddHub_title: "افزودن هاب",
  AddHub_text: "دستگاه اسکن شده 'هاب لکسا' است. در صورت تمایل به اضافه کردن آن، گزینه ادامه را انتخاب کنید.",
  AddHub_button: "ادامه",
  AddHubTurnOn_title: "اتصال به برق",
  AddHubTurnOn_text: "لطفا هاب را به یک منبع برق متصل کرده و با استفاده از دکمه روشن کنید.",
  AddHubTurnOn_button: "ادامه",
  AddHubLedCheck_title: "حالت چراغ هاب",
  AddHubLedCheck_text: "آیا چراغ روی هاب، سرخ ثابت است؟",
  AddHubLedCheck_button: "بله",
  AddHubLedCheck_button2: "خیر",
  AddHubLedError_title: "هشدار",
  AddHubLedError_text: "این هاب دارای مدیر است. برای اتصال از مدیر درخواست کنید به شما دسترسی دهد. یا می توانید گزینه 'تنظیم مجدد هاب' را انتخاب نمایید.",
  AddHubLedError_button: "تنظیم مجدد هاب",
  AddHubLedError_Cancel: "لغو",
  AddHubReset_title: "تنظیم مجدد هاب",
  AddHubReset_text:
    "با استفاده از یک سوزن، دکمه ریست تعبیه شده در سوراخ کوچک پشت هاب را نگه دارید تا رنگ چراغ LED روی هاب به صورت چشمک زن سرخ و آبی شود. سپس دکمه را رها کنید تا تمامی کاربران این هاب پاک شوند. در صورتی که می خواهید هاب به طور کامل پاک شود، دکمه را تا چشمک سریع سرخ و آبی نگه دارید..",
  AddHubReset_button: "ادامه",
  AddHubSecurity_title: "امنیت در اتصال",
  AddHubSecurity_text: "برای بهره مندی از بالاترین سطح امنیت، می توانید با گذاشتن رمز روی هاب، از تایید هویت دو مرحله ای استفاده کنید.",
  AddHubSecurity_button: "امنیت دو مرحله ای",
  AddHubSecurity_button2: "امنیت معمولی",
  AddHubSetPassword_title: "امنیت دو مرحله ای",
  AddHubSetPassword_text: "این رمز، رمز این هاب بوده و ربطی به رمز حساب کاربری شما ندارد.",
  AddHubSetPassword_placeHolder: "رمز هاب",
  AddHubSetPassword_placeHolder2: "تکرار رمز هاب",
  AddHubSetPassword_button: "ادامه",
  AddHubSetPassword_alert_passwordEmpty: "لطفا برای این هاب یک رمز وارد نمایید.",
  AddHubSetPassword_alert_passwordNotMatch: "تکرار رمز با رمز همخوانی ندارد.",
  AddHubNameColor_title: "شخصی سازی هاب",
  AddHubNameColor_text: "لطفا نام و رنگ این هاب را انتخاب نمایید.",
  AddHubNameColor_placeHolder: "نام (خانه، دفتر ...)",
  AddHubNameColor_button: "ادامه",
  AddHubNameColor_alert_nameEmpty: "لطفا نام یا مکان استفاده از این هاب را وارد نمایید.",
  AddHubConnectWifi_title: "اتصال به هاب",
  AddHubConnectWifi_text: "لطفا به صفحه تنظیمات موبایل خود رفته و به شبکه Wi-Fi زیر متصل شوید. سپس به اپلیکیشن لکسا باز گشته و گزینه 'اتصال به هاب' را انتخاب نمایید.",
  AddHubConnectWifi_button: "اتصال به هاب",
  AddHubNotFound_Cancel: "لغو",
  AddHubNotFound_title: "خطا در اتصال به هاب",
  AddHubNotFound_text: "متاسفانه اتصال به هاب موفقیت آمیز نبود. لطفا از اتصال خود به شبکه Wi-Fi هاب اطمینان حاصل کرده و مجددا تلاش کنید.",
  AddHubNotFound_button: "تلاش مجدد",
  AddHubSuccess_title: "ثبت موفق",
  AddHubSuccess_text: "هاب لکسا شما با موفقیت ثبت شد. می توانید در صفحه 'دستگاه ها' این هاب را ببینید و تنظیمات آن را تغییر دهید.",
  AddHubSuccess_button: "تمام",
  AddNode2_title: "ماژول روشنایی دو کاناله",
  AddNode2_text: "دستگاه اسکن شده 'ماژول روشنایی دو کاناله' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode2_button: "ادامه",
  AddNode3_title: "ماژول روشنایی تک کاناله",
  AddNode3_text: "دستگاه اسکن شده 'ماژول روشنایی تک کاناله' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode3_button: "ادامه",
  AddNode4_title: "ماژول روشنایی تبدیل",
  AddNode4_text: "دستگاه اسکن شده 'ماژول روشنایی تبدیل' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode4_button: "ادامه",
  AddNode5_title: "ماژول سوییچینگ عمومی",
  AddNode5_text: "دستگاه اسکن شده 'ماژول سوییچینگ عمومی' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode5_button: "ادامه",
  AddNode6_title: "سنسور دما رطوبت",
  AddNode6_text: "دستگاه اسکن شده 'سنسور دما رطوبت' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode6_button: "ادامه",
  AddNodeSelectHub_title: "انتخاب هاب",
  AddNodeSelectHub_text: "لطفا هاب مربوط به دستگاه اسکن شده را انتخاب نمایید.",
  AddNodeNameColor_title: "شخصی سازی دستگاه",
  AddNodeNameColor_text: "لطفا نام و رنگ این دستگاه را انتخاب نمایید.",
  AddNodeNameColor_button: "ثبت",
  AddNodeNameColor_placeHolder: "نام دستگاه",
  AddNodeNameColor_alert_nameEmpty: "لطفا یک نام برای دستگاه انتخاب کنید.",
  AddNodeNameColor_alert_duplicateNode: "این دستگاه قبلا ثبت شده است!",
  AddNodeSuccess_title: "ثبت موفق",
  AddNodeSuccess_text: "دستگاه شما با موفقیت به خانه هوشمند شما اضافه شد. برای استفاده از آن، باید در صفحه 'دستگاه ها' اتصال آن را با هاب برقرار نمایید.",
  AddNodeSuccess_button: "تمام",
  AddNodeHubNotFound_title: "خطا در اتصال به هاب",
  AddNodeHubNotFound_text: "متاسفانه اتصال به هاب موفقیت آمیز نبود. لطفا از اتصال خود به شبکه Wi-Fi هاب اطمینان حاصل کرده و مجددا تلاش کنید.",
  AddNodeHubNotFound_button: "تلاش مجدد",
  PairNode_title: "اتصال دستگاه با هاب",
  PairNode_text: "شما باید این دستگاه را به یک هاب متصل کنید. قبل از فشردن دکمه، مطمئن شوید هاب شما روشن بوده و به اپ وصل است.",
  PairNode_button: "اتصال به دستگاه",
  PairNode_button2: "حذف دستگاه",
  PairNodeSuccess_title: "اتصال موفق",
  PairNodeSuccess_text: "دستگاه شما با موفقیت به هاب متصل شد و آماده استفاده است.",
  PairNodeSuccess_button: "تمام",
  PairNodeHubNotResponding_title: "خطا در اتصال به هاب",
  PairNodeHubNotResponding_text: "متاسفانه اتصال به هاب موفقیت آمیز نبود. لطفا از اتصال خود به شبکه Wi-Fi هاب اطمینان حاصل کرده و مجددا تلاش کنید.",
  PairNodeHubNotResponding_button: "تلاش مجدد",
  PairNodeNodeNotResponding_title: "خطا در اتصال به دستگاه",
  PairNodeNodeNotResponding_text: "دستگاه شما توسط هاب لکسا پیدا نشد. لطفا از روشن بودن دستگاه اطمینان حاصل نمایید.",
  PairNodeNodeNotResponding_button: "تلاش مجدد",
  Node2Settings_title1: "شخصی سازی دستگاه",
  Node2Settings_title2: "اطلاعات دستگاه",
  Node2Settings_title3: "حالت های پیش فرض",
  Node2Settings_button: "ذخیره تغییرات",
  Node2Settings_button2: "حذف دستگاه",
  Node2Settings_text1: "نام",
  Node2Settings_default1: "مستقیم، ورودی ۱ و ۲ به خروجی ۱ و ۲",
  Node2Settings_default2: "غیر مستقیم، ورودی ۱ و ۲ به خروجی ۱ و ۲",
  Node2Settings_default3: "مستقیم، ورودی ۱ و ۲ به خروجی ۲ و ۱",
  Node2Settings_default4: "غیر مستقیم، ورودی ۱ و ۲ به خروجی ۲ و ۱",
  Node3Settings_default1: "مستقیم، ورودی ۱ به خروجی ۱",
  Node3Settings_default2: "غیر مستقیم، ورودی ۱ به خروجی ۱",
  Node4Settings_default1: "کلید تبدیل",
  Node2Settings_deviceStatus: "وضعیت",
  Node2SettingsHubNotResponding_title: "خطا در اتصال به هاب",
  Node2SettingsHubNotResponding_text: "متاسفانه اتصال به هاب موفقیت آمیز نبود. لطفا از اتصال خود به شبکه Wi-Fi هاب اطمینان حاصل کرده و مجددا تلاش کنید.",
  Node2SettingsHubNotResponding_button: "بازگشت",
  Node2SettingsSuccess_title: "عملیات موفق",
  Node2SettingsSuccess_text: "تنظیمات جدید با موفقیت روی دستگاه شما اعمال شد.",
  Node2SettingsSuccess_button: "بازگشت",
  Node2SettingsNodeNotResponding_title: "خطا در اتصال به دستگاه",
  Node2SettingsNodeNotResponding_text: "دستگاه شما توسط هاب لکسا پیدا نشد. لطفا از روشن بودن دستگاه اطمینان حاصل نمایید.",
  Node2SettingsNodeNotResponding_button: "بازگشت",
  Node2Settings_alert: "لطفا یک نام برای دستگاه انتخاب کنید.",
  Node2Settings_timerTimeout: "زمان تایمر(ثانیه).",
  DeleteDevice_title: "هشدار",
  DeleteDevice_text: "شما در حال پاک کردن این دستگاه هستید. برای اضافه کردن مجدد این دستگاه باید کد QR روی برچسب آن را اسکن کنید. آیا اطمینان دارید؟",
  DeleteDevice_button: "بله",
  DeleteDevice_button2: "خیر",
  DeleteDeviceSuccess_title: "عملیات موفق",
  DeleteDeviceSuccess_text: "این دستگاه با موفقیت از خانه هوشمند شما پاک شد.",
  DeleteDeviceSuccess_button: "بازگشت",
  RelaySSR2ASettings_title1: "خروجی",
  RelaySSR2ASettings_text1: "وضعیت خروجی",
  RelaySSR2ASettings_switchState_On: "روشن",
  RelaySSR2ASettings_switchState_Off: "خاموش",
  RelaySSR2ASettings_title2: "تنظیمات خروجی",
  RelaySSR2ASettings_text2: "نوع خروجی",
  RelaySSR2ASettings_text3: "نام",
  RelaySSR2ASettings_text4: "وضعیت بعد از قطع و وصل برق",
  RelaySSR2ASettings_button: "ذخیره تغییرات",
  RelaySSR2ASettings_initState1: "روشن",
  RelaySSR2ASettings_initState2: "خاموش",
  RelaySSR2ASettings_outputType1: "روشنایی",
  RelaySSR2ASettings_outputType2: "آبیاری",
  RelaySSR2ASettings_outputType3: "سرمایش",
  RelaySSR2ASettings_outputType4: "گرمایش",
  RelaySSR2ASettings_outputType5: "دروازه",
  RelaySSR2ASettings_alert: "لطفا یک نام برای این خروجی انتخاب کنید.",
  ZeroContactSettings_title1: "ورودی",
  ZeroContactSettings_text1: "وضعیت ورودی",
  ZeroContactSettings_title2: "تنظیمات ورودی",
  ZeroContactSettings_text2: "نوع ورودی",
  ZeroContactSettings_inputType1: "کلید معمولی",
  ZeroContactSettings_inputType2: "کلید فشاری",
  ZeroContactSettings_inputType3: "سنسور دود",
  ZeroContactSettings_inputType4: "سنسور حضور",
  ZeroContactSettings_text3: "نام ورودی",
  ZeroContactSettings_text4: "جهت",
  ZeroContactSettings_alert: "لطفا یک نام برای این ورودی انتخاب کنید.",
  ZeroContactSettings_button: "ذخیره تغییرات",
  ZeroContactSettings_text5: "تاثیر",
  HubSettings_title1: "شخصی سازی دستگاه",
  HubSettings_text1: "نام",
  HubSettings_title2: "مدیریت هاب",
  HubSettings_button: "ذخیره تغییرات",
  HubSettings_button2: "حذف هاب",
  HubSettings_alert: "لطفا یک نام برای این هاب انتخاب کنید.",
  HubSettings_title3: "وضعیت",
  HubSettings_button3: "بروز رسانی نرم افزار",
  HubSettings_button4: "مدیریت کاربران",
  HubSettings_button5: "مدیریت شبکه Wi-Fi هاب",
  DeleteHub_title: "حذف هاب",
  DeleteHub_text:
    "شما در حال حذف این هاب از اپ می باشید. در صورت حذف این هاب، تمامی دستگاه های متصل به این هاب نیز از روی اپلیکیشن شما حذف می شوند. برای اتصال مجدد به این هاب باید از کد UUID و رمز عبور آن استفاده نمایید. آیا مطئن هستید؟",
  DeleteHub_button: "بله",
  DeleteHub_button2: "خیر",
  OTA_title: "به روز رسانی نرم افزار",
  OTA_text:
    "شما در حال به روز رسانی نرم افزار هاب به آخرین نسخه هستید. لطفا از اتصال هاب به اینترنت و تغذیه برق هاب اطمینان حاصل کنید. در حین این به روز رسانی به هیچ عنوان برق هاب را قطع نکنید. آیا مطمئن هستید؟",
  OTA_button: "بله",
  OTA_button2: "خیر",
  OtaSuccess_title: "عملیات موفق",
  OtaSuccess_text: "نرم افزار هاب شما در حال به روز رسانی است. تا وقتی که چراغ هاب در حال چشمک زن سریع است، برق هاب را قطع نکنید. بعد از ثابت شدن حالت چراغ هاب، آن را یک بار خاموش و روشن نمایید.",
  OtaSuccess_button: "پایان",
  HubNetworkSettings_title: "تنظیمات شبکه Wi-Fi هاب",
  HubNetworkSettings_text1: "نوع شبکه",
  HubNetworkSettings_text2: "نام شبکه (SSID)",
  HubNetworkSettings_text3: "رمز عبور Wi-Fi",
  HubNetworkSettings_alert: "متاسفانه درخواست شما انجام نشد. لطفا مجددا تلاش نمایید.",
  HubNetworkSettings_button: "ذخیره تغییرات",
  HubNetworkSettings_alert2: "لطفا نام شبکه را وارد نمایید.",
  HubNetworkSettingsSuccess_title: "عملیات موفق",
  HubNetworkSettingsSuccess_text: "تنظیمات شبکه هاب با موفقیت انجام شد. لطفا تنظیمات Wi-Fi موبایل خود را به گونه ای تغییر دهید که با هاب در یک شبکه باشید.",
  HubNetworkSettingsSuccess_button: "پایان",
  HubUserSettings_title: "کاربران",
  HubUserSettings_button: "افزودن کاربر جدید",
  EditUser_title1: "ویرایش کاربر",
  EditUser_text1: "شماره موبایل",
  EditUser_text2: "سطح دسترسی",
  EditUser_text3: "نام کاربر",
  EditUser_button1: "حذف کاربر",
  EditUser_button2: "ذخیره تغییرات",
  EditUser_alert: "لطفا نام کاربر را وارد نمایید.",
  EditUser_ownerText: "مدیر",
  EditUser_normalText: "عادی",
  AddNewUser_title: "افزودن کاربر جدید",
  AddNewUser_text: "برای اضافه کردن کاربر جدید، شماره موبایل و نام کاربر جدید را وارد نمایید.",
  AddNewUser_placeHolder: "شماره موبایل",
  AddNewUser_placeHolder2: "نام کاربر",
  AddNewUser_button: "افزودن کاربر",
  AddNewUser_alert1: "لطفا شماره موبایل کاربر جدید را وارد نمایید.",
  AddNewUser_alert2: "لطفا نام کاربر جدید را وارد نمایید.",
  AddNewUser_alert3: "این کاربر قبلا در هاب شما ثبت شده است.",
  AddNewUser_serverResponseFail: "درخواست شما انجام نشد. لطفا شماره موبایل وارد شده را چک کنید و مجددا تلاش نمایید.",
  NewUserCredentials_title: "کاربر جدید",
  NewUserCredentials_text:
    "کاربر جدید با موفقیت به هاب شما اضافه شد و از این پس می تواند با وارد کردن اطلاعات زیر، به آن متصل شود. لطفا این صفحه را ذخیره و اطلاعات زیر را برای کاربر جدید ارسال کنید.",
  NewUserCredentials_button: "تمام",
  DeleteUser_title: "حذف کاربر",
  DeleteUser_text: "آیا از حذف این کاربر از هاب خود مطمئن هستید؟",
  DeleteUser_button: "بله",
  DeleteUser_button2: "خیر",
  HubLogin_title: "اتصال به هاب یا دستگاه",
  HubLogin_text: "لطفا پس از اطمینان از قرار گرفتن در شبکه Wi-Fi دستگاه، اطلاعات دریافت شده از مدیر را در فرم زیر وارد نمایید.",
  HubLogin_placeHolder: "UUID دستگاه",
  HubLogin_placeHolder2: "رمز عبور",
  HubLogin_button: "اتصال",
  HubLogin_alert1: "لطفا UUID دستگاه را وارد نمایید.",
  HubLogin_alert2: "لطفا رمز عبور خود را وارد نمایید.",
  HubLogin_alert3: "شما قبلا به این دستگاه متصل شده اید.",
  HubLoginSuccess_title: "ورود موفق",
  HubLoginSuccess_text: "شما با موفقیت به این دستگاه متصل شدید.",
  HubLoginSuccess_button: "تمام",
  HubLoginNotFound_title: "ورود ناموفق",
  HubLoginNotFound_text: "دستگاه مورد نظر شما در شبکه پیدا نشد. لطفا از اتصال خود به شبکه Wi-Fi دستگاه مطمئن شوید و همچنین UUID دستگاه را چک کنید.",
  HubLoginNotFound_button: "تلاش مجدد",
  HubLoginError_title: "ورود ناموفق",
  HubLoginError_text: "رمز عبور وارد شده نادرست است. لطفا مجددا تلاش کنید و یا با مدیر این دستگاه تماس بگیرید.",
  HubLoginError_button: "تلاش مجدد",
  MainMenu_title: "منوی اصلی",
  MainMenu_button1: "انتخاب زبان",
  MainMenu_button2: "خروج",
  LogOut_title: "خروج",
  LogOut_text: "آیا مایل به خروج از برنامه هستید؟",
  LogOut_button: "بله",
  LogOut_button2: "خیر",
  TemperatureSensorSettings_title1: "ورودی",
  TemperatureSensorSettings_text1: "دما",
  TemperatureSensorSettings_title2: "تنظیمات ورودی",
  TemperatureSensorSettings_text3: "نام ورودی",
  TemperatureSensorSettings_button: "ذخیره تغییرات",
  HumiditySensorSettings_title1: "ورودی",
  HumiditySensorSettings_text1: "رطوبت",
  HumiditySensorSettings_title2: "تنظیمات ورودی",
  HumiditySensorSettings_text3: "نام ورودی",
  HumiditySensorSettings_button: "ذخیره تغییرات",
  DashBoard_noWidgets: "هیچ ویجتی پیدا نشد.",
  Dashboard_editWidgets: "ویرایش",
  DashBoard_addWidget: "اضافه کردن ویجت",
  Dashboard_doneEditing: "ذخیره",
  LuxinWidget_singleSwitch: "سوییچ تک",
  DeleteWidget_title: "حذف ویجت",
  DeleteWidget_text: "آیا از حذف این ویجت مطمئن هستید؟",
  DeleteWidget_button: "بله",
  DeleteWidget_button2: "خیر",
  Scenarios_addScenario: "اضافه کردن سناریو",
  Scenarios_noscenario: "هیچ سناریویی پیدا نشد.",
  AddScenario_title1: "شخصی سازی سناریو",
  AddScenario_text1: "نام",
  Scenario_namePlaceHolder: "نام سناریو",
  AddScenario_button: "ذخیره",
  AddScenario_alert1: "لطفا یک نام برای سناریو انتخاب کنید.",
  Scenarios_scenarioCommonName: "سناریو",
  EditScenario_deleteButton: "حذف سناریو",
  EditScenario_text5: "هاب",
  DeleteScenario_title: "حذف سناریو",
  DeleteScenario_text: "آیا از حذف این سناریو مطمئن هستید؟",
  DeleteScenario_button: "بله",
  DeleteScenario_button2: "خیر",
  EditWidget_title1: "شخصی سازی ویجت",
  Name_text: "نام",
  WidgetName_PlaceHolder: "نام ویجت",
  SaveChanges_button: "ذخیره تغییرات",
  Output_text: "خروجی",
  ChooseHub_text: "انتخاب هاب",
  ChooseOutput_text: "انتخاب خروجی",
  WidgetName_alert: "لطفا نام ویجت را وارد نمایید.",
  AddNewWidget_button: "افزودن",
  AddNewWidget_singleSwitchDescription: "یک سوییچ تک برای خاموش و روشن کردن خروجی ها با فیدبک لایو.",
  Save_button: "ذخیره",
  TemperatureSensorSettings_title3: "شرط ها",
  TemperatureSensorSettings_unknownScenario: "سناریو نامعلوم",
  TemperatureSensorSettings_title4: "افزودن شرط",
  TemperatureSensorSettings_rising: "بیشتر بشود",
  TemperatureSensorSettings_falling: "کمتر بشود",
  TemperatureSensorSettings_text2: "نوع شرط",
  TemperatureSensorSettings_text4: "انتخاب سناریو",
  TemperatureSensorSettings_button2: "اضافه کردن شرط",
  TemperatureSensorSettings_button3: "ذخیره شرط ها",
  TemperatureSensorSettings_button4: "افزودن سناریو",
  HubSettings_title4: "تنظیمات",
  HubSettings_button6: "همگام سازی تنظیمات",
  HubSettings_button7: "ذخیره تنظیمات",
  DeleteUser_serverError: "خطا در ارتباط با سرور. لطفا بعدا تلاش نمایید.",
  HubSettings_serverError: "خطا در ارتباط با سرور. لطفا بعدا تلاش نمایید.",
  HubSettings_noSnapshotsFound: "تنظیمات پیدا نشد.",
  AddNewWidget_sceneButtonDescription: "یک دکمه برای اجرای سناریوی دلخواه شما.",
  LuxinWidget_sceneButton: "دکمه سناریو",
  SceneButton_runScene: "اجرا",
  AddSceneButtonWidget_button: "ذخیره",
  EditSceneButtonWidget_button: "ذخیره",
  DeleteDevice_alert: "شما دسترسی به انجام این عملیات ندارید.",
  Node2Settings_default5: "تغییر وضعیت، ورودی ۱ و ۲ به خروجی ۱ و ۲",
  Node2Settings_default6: "تغییر وضعیت، ورودی ۱ و ۲ به خروجی ۲ و ۱",
  Node3Settings_default3: "تغییر وضعیت",
  HubNetworkSettings_alert3: "لطفا رمز شبکه را وارد نمایید.",
  AddNewDeviceUploadQR_alert2: "کد QR در تصویر انتخاب شده پیدا نشد.",
  AddNewDeviceUploadQR_alert3: "اسکن کد QR انتخاب شده با مشکل مواجه شد.",
  AddNode7_title: "کنترلر IR",
  AddNode7_text: "دستگاه اسکن شده 'کنترلر IR' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode7_button: "ادامه",
  NODE7_INPUT1_NAME: "دما",
  NODE7_INPUT2_NAME: "رطوبت",
  Node7Settings_IrDevice: "دستگاه IR",
  Node7Settings_addIrDevice: "افزودن دستگاه IR",
  AddIrDevice_title1: "شخصی سازی",
  AddIrDevice_text1: "نام",
  AddIrDevice_namePlaceHolder: "نام دستگاه IR",
  AddIrDevice_button: "ذخیره",
  AddIrDevice_title2: "انتخاب دستگاه",
  AddIrDevice_text2: "نوع دستگاه",
  AddIrDevice_text3: "برند",
  NODE7_AC_NAME: "ایرکندیشن",
  AddIrDevice_text4: "مدل",
  AddIrDevice_testDevice: "تست دستگاه",
  AddIrDevice_text5:
    "لطفا کنترلر IR لکسا خود را به سمت دستگاه مورد نظر گرفته و دکمه 'تست دستگاه' را فشار دهید. در صورتی که دستگاه کار کرد، گزینه 'ذخیره' را انتخاب کنید و در غیر این صورت، مدل های دیگر را انتخاب کنید.",
  AddIrDevice_alert1: "لطفا نام دستگاه را وارد نمایید.",
  IrDeviceSettings_button2: "حذف دستگاه IR",
  DeleteIrDevice_title: "حذف دستگاه IR",
  DeleteIrDevice_text: "آیا مایل به حذف این دستگاه IR می باشید؟",
  DeleteIrDevice_button: "بله",
  DeleteIrDevice_button2: "خیر",
  IrDeviceSettings_title3: "ریموت کنترل",
  IrDeviceSettings_showRemote: "نمایش ریموت کنترل",
  AddIrDevice_turnDeviceOff: "خاموش کردن دستگاه",
  DashBoard_scehdule: "زمان بندی ها",
  weekDays: ["یکشنبه", "دوشنبه", "سه شنبه", "چهار شنبه", "پنچ شنبه", "جمعه", "شنبه"],
  weekDaysShort: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
  months: ["حمل", "ثور", "جوزا", "سرطان", "اسد", "سنبله", "میزان", "عقرب", "قوس", "جدی", "دلو", "حوت"],
  AddSchedule_title1: "شخصی سازی",
  AddSchedule_text1: "نام",
  AddSchedule_namePlaceHolder: "نام زمان بندی",
  AddSchedule_text2: "انتخاب هاب",
  AddSchedule_text3: "ساعت",
  AddSchedule_text4: "دقیقه",
  AddSchedule_title2: "انتخاب زمان",
  AddSchedule_button: "ذخیره",
  AddSchedule_text5: "تکرار",
  AddSchedule_title3: "ساخت فرمان",
  AddSchedule_button2: "افزودن سناریو",
  AddSchedule_alert1: "لطفا یک نام برای زمان بندی انتخاب کنید.",
  Schedules_schedule: "زمان بندی",
  Schedules_button: "افزودن زمان بندی",
  Schedules_loadError: "مشکل در دریافت اطلاعات زمان بندی ها",
  Schedules_noSchedule: "زمان بندی پیدا نشد.",
  Schedules_time: "زمان: ",
  Schedules_repeat: "تکرار: ",
  AddScheduleSuccess_title: "عملیات موفق",
  AddScheduleSuccess_text: "برنامه زمان بندی شما با موفقیت در سیستم ثبت شد.",
  AddScheduleSuccess_button: "تمام",
  Schedules_todayOnly: "فقط امروز",
  DeleteSchedule_title: "حذف زمان بندی",
  DeleteSchedule_text: "آیا از حذف این زمان بندی اطمینان دارید؟",
  DeleteSchedule_button: "بله",
  DeleteSchedule_button2: "خیر",
  Schedules_alert: "هیچ هاب ای در سیستم شما پیدا نشد",
  RelaySSR2ASettings_switchState_Unknown: "در حال بروزرسانی...",
  CommandCreator_title2: "فرمان ها",
  CommandCreator_title3: "ساخت فرمان",
  CommandCreator_text2: "انتخاب خروجی",
  CommandCreator_text3: "وضعیت خروجی",
  CommandCreator_text4: "تاخیر (ثانیه)",
  CommandCreator_outputStateOn: "روشن",
  CommandCreator_outputStateOff: "خاموش",
  CommandCreator_outputStateToggle: "تغییر وضعیت",
  CommandCreator_button2: "اضافه کردن فرمان",
  CommandCreator_outputStateTitle: "وضعیت",
  CommandCreator_delayTitle: "تاخیر",
  CommandCreator_delaySecond: "ثانیه",
  CommandCreator_alert2: "لطفا حداقل یک فرمان بسازید.",
  CommandCreator_text5: "انتخاب هاب",
  CommandCreator_alertNoOutputs: "هیچ خروجی ای برای هاب انتخاب شده پیدا نشد",
  NoOutPutForHub_alert: "هیچ خروجی ای برای هاب انتخاب شده پیدا نشد",
  NoInstalledHub_alert: "شما هیچ هاب نصب شده ای ندارید.",
  CommandCreator_alertNoHubs: "شما هیچ هاب نصب شده ای ندارید.",
  CommandCreator_alertPacketOverflow: "اندازه فرمان شما از حد مجاز بیشتر شده است.",
  CommandCreator_button3: "ایجاد فرمان",
  AddTemperatureAutomationWidget_title1: "شخصی سازی ویجت",
  AddTemperatureAutomationWidget_text1: "نام",
  AddTemperatureAutomationWidget_namePlaceHolder: "نام ویجت",
  AddTemperatureAutomationWidget_title2: "تنظیمات اتوماسیون",
  AddTemperatureAutomationWidget_automationType1: "سرمایش و گرمایش",
  AddTemperatureAutomationWidget_automationType2: "سرمایش",
  AddTemperatureAutomationWidget_automationType3: "گرمایش",
  AddTemperatureAutomationWidget_text2: "نوع اتوماسیون",
  AddTemperatureAutomationWidget_text3: "انتخاب فصل",
  AddTemperatureAutomationWidget_targetSeason1: "تابستان",
  AddTemperatureAutomationWidget_targetSeason2: "زمستان",
  AddTemperatureAutomationWidget_text4: "انتخاب سنسور دما",
  AddTemperatureAutomationWidget_text5: "انتخاب هاب",
  AddTemperatureAutomationWidget_cool_on_description: "لطفا فرمان مربوط به روشن شدن سیستم سرمایش را بسازید.",
  AddTemperatureAutomationWidget_cool_off_description: "لطفا فرمان مربوط به خاموش شدن سیستم سرمایش را بسازید.",
  AddTemperatureAutomationWidget_heat_on_description: "لطفا فرمان مربوط به روشن شدن سیستم گرمایش را بسازید.",
  AddTemperatureAutomationWidget_heat_off_description: "لطفا فرمان مربوط به خاموش شدن سیستم گرمایش را بسازید.",
  AddTemperatureAutomationWidget_cool_text: "خروجی سرمایشی",
  AddTemperatureAutomationWidget_heat_text: "خروجی گرمایشی",
  AddTemperatureAutomationWidget_humidity_text: "خروجی",
  AddTemperatureAutomationWidget_button: "ذخیره",
  AddTemperatureAutomationWidget_alertNoSensor: "هیچ سنسور دمایی در هاب انتخاب شده وجود ندارد.",
  AddTemperatureAutomationWidget_alertCoolOnNoCommand: "لطفا فرمان مربوط به روشن شدن سیستم سرمایش را بسازید.",
  AddTemperatureAutomationWidget_alertCoolOffNoCommand: "لطفا فرمان مربوط به خاموش شدن سیستم سرمایش را بسازید.",
  AddTemperatureAutomationWidget_alertHeatOnNoCommand: "لطفا فرمان مربوط به روشن شدن سیستم گرمایش را بسازید.",
  AddTemperatureAutomationWidget_alertHeatOffNoCommand: "لطفا فرمان مربوط به خاموش شدن سیستم گرمایش را بسازید.",
  AddTemperatureAutomationWidget_alertHubFailed: "خطا در اتصال به هاب. لطفا از اتصال خود با هاب مورد نظر مطمئن شوید.",
  AddTemperatureAutomationWidget_alertSensorFailed: "خطا در ارتباط با سنسور دما. اتوماسیون شما اضافه شد ولی از روشن بودن سنسور دما اطمینان حاصل نمایید.",
  LuxinWidget_temperatureAutomation: "اتوماسیون دما",
  TemperatureAutomationWidget_alertSensorFailed: "تغییرات اعمال شد. ولی از روشن بودن سنسور دما اطمینان حاصل نمایید.",
  EditSingleSwitchWidget_alertNotSync: "خطا در نمایش فرمان ها. لطفا دیتابیس خود را به روز رسانی کنید.",
  AddNewWidget_temperatureAutomationDescription: "کنترل کامل بر روی سرمایش و گرمایش",
  AddTemperatureAutomationWidget_alertNotOwner: "متاسفانه فقط ادمین اجازه اضافه کردن اتوماسیون را دارد.",
  EditTemperatureAutomationWidget_alertNotOwner: "متاسفانه فقط ادمین اجازه ویرایش اتوماسیون را دارد.",
  DeleteTemperatureAutomation_title: "حذف اتوماسیون دما",
  DeleteTemperatureAutomation_text: "آیا مطمئن به حذف این اتوماسیون هستید؟ بعد از حذف، این اتوماسیون از کار خواهد افتاد.",
  DeleteTemperatureAutomation_button: "بله",
  DeleteTemperatureAutomation_button2: "خیر",
  DeleteTemperatureAutomation_alertNotOwner: "متاسفانه فقط ادمین اجازه حذف اتوماسیون را دارد.",
  DeleteTemperatureAutomation_alertDeleteError: "خطا در عملیات!",
  DeleteTemperatureAutomation_alertSensorFailed: "خطا در ارتباط با سنسور دما. اتوماسیون شما حذف شد ولی از روشن بودن سنسور دما اطمینان حاصل نمایید.",
  HubNetworkSettings_alert4: "رمز عبور باید حداقل ۸ کاراکتر باشد.",
  Schedules_commands: "فرمان ها: ",
  Schedules_showCommands: "نمایش فرمان ها",
  AddSchedule_alert5: "لطفا یک فرمان برای این زمان بندی بسازید.",
  AddSchedule_alert6: "شما نمی توانید زمان بندی دیگری اضافه نمایید.",
  DeleteSchedule_alertDeleteError: "خطا در عملیات!",
  Schedules_everyDay: "هر روز",
  AddSchedule_text6: "اتفاق بعدی",
  AddSchedule_button3: "حذف",
  AddNode9_title: "کنترلر RGBW",
  AddNode9_text: "دستگاه اسکن شده 'کنترلر RGBW' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode9_button: "ادامه",
  NODE9_INPUT1_NAME: "ورودی ۱",
  NODE9_OUTPUT1_NAME: "RGB",
  NODE9_OUTPUT2_NAME: "Red",
  NODE9_OUTPUT3_NAME: "Green",
  NODE9_OUTPUT4_NAME: "Blue",
  NODE9_OUTPUT5_NAME: "White",
  Node9Settings_hue: "HUE",
  Node9Settings_rgbw: "RGBW",
  Node9Settings_rgb: "RGB",
  Node9Settings_red: "Red",
  Node9Settings_green: "Green",
  Node9Settings_blue: "Blue",
  Node9Settings_white: "White",
  Node9Settings_alert1: "خطا در اتصال به هاب!",
  Node9Settings_fadeTime: "زمان تغییر رنگ (میلی ثانیه)",
  Node9Settings_animation: "انیمیشن",
  Node9Settings_animation0: "غیر فعال",
  Node9Settings_animation1: "رندوم",
  Node9Settings_animation2: "دایره HUE",
  Node9Settings_default: "رنگ پیش فرض",
  Node2Settings_setAsDefault: "انتخاب به عنوان رنگ پیش فرض",
  Node9Settings_colorPickerType: "پالت رنگ",
  LuxinWidget_RGBW: "کنترلر RGBW",
  AddNewWidget_rgbwDescription: "یک پالت رنگ برای کنترل ریسه های RGBW",
  AddRGBWWidget_button: "ذخیره",
  HubSettings_title5: "دستیار صوتی",
  HubSettings_button8: "آمازون الکسا",
  NODE7_TV_NAME: "تلویزیون",
  AddSchedule_text7: "نوع زمان بندی",
  AddSchedule_text8: "کنترل خروجی ها",
  AddSchedule_text9: "کنترل اتوماسیون ها",
  CommandCreator_text10: "انتخاب اتوماسیون",
  CommandCreator_text11: "وضعیت",
  CommandCreator_alertDuplicateAutomation: "این اتوماسیون قبلا انتخاب شده است.",
  LoginRegister_googleLoginFailed: "خطا در ارتباط با سرور گوگل",
  AddNode8_title: "کنترلر IR/RF",
  AddNode8_text: "دستگاه اسکن شده 'کنترلر IR/RF' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode8_button: "ادامه",
  HubSettings_button9: "دستیار گوگل",
  AddNest_Success: "ارتباط هاب شما با دستیار صوتی گوگل برقرار شد.",
  AddAlexa_Success: "ارتباط هاب شما با دستیار صوتی آمازون الکسا برقرار شد.",
  SelectAddNewUserType_title: "اضافه کردن کاربر",
  SelectAddNewUserType_button1: "با شماره موبایل",
  SelectAddNewUserType_button2: "با اکانت گوگل",
  AddNewUserGoogle_text: "برای اضافه کردن کاربر جدید، آدرس اکانت گوگل و نام کاربر جدید را وارد نمایید.",
  AddNewUserGoogle_placeHolder: "اکانت گوگل",
  AddNewUserGoogle_alert1: "لطفا اکانت گوگل کاربر جدید را وارد نمایید.",
  AddNewUserGoogle_serverResponseFail: "درخواست شما انجام نشد. لطفا اکانت گوگل وارد شده را چک کنید و مجددا تلاش نمایید.",
  Node8Settings_Devices: "دستگاه ها",
  Node8Settings_addRfDevice: "افزودن دستگاه RF",
  AddRfDevice_title1: "شخصی سازی",
  AddRfDevice_text1: "نام",
  AddRfDevice_namePlaceHolder: "نام دستگاه RF",
  AddRfDevice_button: "ذخیره",
  AddRfDevice_title2: "انتخاب دستگاه",
  AddRfDevice_text2: "نوع دستگاه",
  AddRfDevice_testDevice: "برقراری اتصال",
  AddRfDevice_text3: "لطفا دستگاه مورد نظر خود را در حالت Learn قرار دهید و گزینه 'برقراری اتصال' را انتخاب نمایید.",
  AddRfDevice_text4: "اگر اتصال برقرار شد، با دکمه های زیر، کانال ها را تست نمایید، در غیر اینصورت، نوع دستگاه دیگری را انتخاب نمایید.",
  AddRfDevice_alert1: "لطفا نام دستگاه را وارد نمایید.",
  AddRfDevice_testChannel1: "تست کانال ۱",
  AddRfDevice_testChannel2: "تست کانال ۲",
  AddRfDevice_testChannel3: "تست کانال ۳",
  AddRfDevice_testChannel4: "تست کانال ۴",
  RfDeviceSettings_button2: "حذف دستگاه RF",
  DeleteRfDevice_title: "حذف دستگاه RF",
  DeleteRfDevice_text: "آیا مایل به حذف این دستگاه RF می باشید؟",
  DeleteRfDevice_button: "بله",
  DeleteRfDevice_button2: "خیر",
  AddSmartCurtainWidget_title1: "شخصی سازی ویجت",
  AddSmartCurtainWidget_text1: "نام",
  AddSmartCurtainWidget_namePlaceHolder: "نام ویجت",
  AddSmartCurtainWidget_title2: "تنظیمات ویجت",
  AddSmartCurtainWidget_curtainType1: "بالا رو",
  AddSmartCurtainWidget_curtainType2: "کنار رو",
  AddSmartCurtainWidget_text2: "نوع پرده",
  AddSmartCurtainWidget_text3: "انتخاب هاب",
  AddSmartCurtainWidget_commands: "فرمان ها",
  AddSmartCurtainWidget_up_description: "لطفا فرمان مربوط به بالا رفتن پرده را بسازید.",
  AddSmartCurtainWidget_stop_description: "لطفا فرمان مربوط به توقف پرده را بسازید.",
  AddSmartCurtainWidget_down_description: "لطفا فرمان مربوط به پایین آمدن پرده را بسازید.",
  AddSmartCurtainWidget_left_description: "لطفا فرمان مربوط به چپ رفتن پرده را بسازید.",
  AddSmartCurtainWidget_right_description: "لطفا فرمان مربوط به راست رفتن پرده را بسازید.",
  CommandCreator_textTargetRfCommand: "انتخاب کانال",
  CommandCreator_channel: "کانال",
  CommandCreator_selectedChannel: "کانال انتخاب شده",
  AddSmartCurtainWidget_alertCurtainUpNoCommand: "لطفا فرمان مربوط به بالا رفتن پرده را بسازید.",
  AddSmartCurtainWidget_alertCurtainDownNoCommand: "لطفا فرمان مربوط به پایین آمدن پرده را بسازید.",
  AddSmartCurtainWidget_alertCurtainLeftNoCommand: "لطفا فرمان مربوط به چپ رفتن پرده را بسازید.",
  AddSmartCurtainWidget_alertCurtainRightNoCommand: "لطفا فرمان مربوط به راست رفتن پرده را بسازید.",
  AddSmartCurtainWidget_alertCurtainStopNoCommand: "لطفا فرمان مربوط به توقف پرده را بسازید.",
  AddSmartCurtainWidget_button: "ذخیره",
  LuxinWidget_SmartCurtain: "پرده هوشمند",
  AddNewWidget_smartCurtainDescription: "کنترل پرده های هوشمند کنار رو و بالا رو",
  RfDeviceSettings_title1: "دستگاه",
  AddDoubleSwitchWidget_text1: "انتخاب خروجی ۱",
  AddDoubleSwitchWidget_text2: "انتخاب خروجی ۲",
  AddDoubleSwitchWidget_title1: "خروجی ۱",
  AddDoubleSwitchWidget_title2: "خروجی ۲",
  LuxinWidget_doubleSwitch: "سوییچ دوبل",
  AddNewWidget_doubleSwitchDescription: "دو سوییچ برای خاموش و روشن کردن دو خروجی با فیدبک لایو.",
  AddAcRemoteWidget_title1: "ریموت",
  LuxinWidget_acRemote: "ریموت ایرکندیشن",
  AddNewWidget_acRemoteDescription: "یک ریموت کامل برای کنترل ایرکندیشن به همراه LCD",
  AddAcRemoteWidget_text1: "انتخاب ریموت",
  AddTemperatureWidget_title1: "سنسور دما",
  AddTemperatureWidget_text1: "انتخاب سنسور دما",
  LuxinWidget_temperatureWidget: "سنسور دما",
  TemperatureWidget_alert1: "سنسور آفلاین است",
  AddNewWidget_temperatureWidgetDescription: "یک ویجت برای نمایش دمای سنسور دما",
  AddNode11_title: "پریز هوشمند",
  AddNode11_text: "دستگاه اسکن شده 'پریز هوشمند' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode11_button: "ادامه",
  Node11Settings_hue: "وضعیت چراغ (HSV)",
  Node11Settings_rgb: "وضعیت چراغ (RGB)",
  Node11Settings_default: "تنظیمات چراغ",
  Node11Settings_setAsOnColor: "انتخاب رنگ حالت روشن",
  Node11Settings_setAsOffColor: "انتخاب رنگ حالت خاموش",
  RelaySSR2ASettings_initState6: "آخرین وضعیت",
  AddNode10_title: "درایور RGB مدل ۲۲۰ ولت",
  AddNode10_text: "دستگاه اسکن شده 'درایور RGB مدل ۲۲۰ ولت' لکسا است. برای اضافه کردن آن، گزینه 'ادامه' را انتخاب نمایید.",
  AddNode10_button: "ادامه",
  Node10Settings_rgb: "RGB",
  Node10Settings_outputPower: "توان خروجی",
  Node2Settings_powerOutputDesc: "برای تنظیم درصد توان خروجی، از این قسمت استفاده کنید. برای استفاده از ریسه های بالای ۳۰ متر، حتما این عدد را روی ۷۰% یا پایین تر تنظیم کنید.",
  Node10Settings_rgbOrder: "ترتیب رنگ ها",
  Node2Settings_colorOrderDesc: "در بعضی ریسه ها، ترتیب رنگ های قرمز، سبر و آبی متفاوت است. در این قسمت می توانید این ترتیب را تغییر دهید.",
  Node10Settings_rgbOrder1: "R-G-B",
  Node10Settings_rgbOrder2: "R-B-G",
  Node10Settings_rgbOrder3: "G-R-B",
  Node10Settings_rgbOrder4: "G-B-R",
  Node10Settings_rgbOrder5: "B-R-G",
  Node10Settings_rgbOrder6: "B-G-R",
  AddRGBStandAlone_title: "افزودن کنترلر RGB WiFi",
  AddRGBStandAlone_text: "دستگاه اسکن شده 'کنترلر RGB WiFi' است. در صورت تمایل به اضافه کردن آن، گزینه ادامه را انتخاب کنید.",
  AddRGBStandAlone_button: "ادامه",
  AddRGBStandAloneTurnOn_title: "اتصال به برق",
  AddRGBStandAloneTurnOn_text: "لطفا دستگاه را به یک منبع برق متصل کرده و آن را روشن کنید.",
  AddRGBStandAloneTurnOn_button: "ادامه",
  AddStandAloneLedCheck_title: "حالت چراغ دستگاه",
  AddStandAloneLedCheck_text: "آیا چراغ روی دستگاه (روزنه کنار جک هدفون)، خاموش است؟",
  AddStandAloneLedCheck_button: "بله",
  AddStandAloneLedCheck_button2: "خیر",
  AddRGBStandAloneLedError_title: "هشدار",
  AddRGBStandAloneLedError_text: "این دستگاه دارای مدیر است. برای اتصال از مدیر درخواست کنید به شما دسترسی دهد. یا می توانید گزینه 'تنظیم مجدد دستگاه' را انتخاب نمایید.",
  AddRGBStandAloneLedError_button: "تنظیم مجدد دستگاه",
  AddRGBStandAloneReset_title: "تنظیم مجدد دستگاه",
  AddRGBStandAloneReset_text:
    "با استفاده از یک سوزن، دکمه ریست تعبیه شده در سوراخ ریز Factory Reset را نگه دارید تا رنگ چراغ LED داخل روزنه ریز کنار جک هدفون روی دستگاه به صورت چشمک زن آبی شود. سپس دکمه را رها کنید تا تمامی کاربران این دستگاه پاک شوند..",
  AddRGBStandAloneReset_button: "ادامه",
  AddRGBStandAloneSecurity_title: "امنیت در اتصال",
  AddRGBStandAloneSecurity_text: "برای بهره مندی از بالاترین سطح امنیت، می توانید با گذاشتن رمز روی دستگاه از تایید هویت دو مرحله ای استفاده کنید.",
  AddRGBStandAloneSecurity_button: "امنیت دو مرحله ای",
  AddRGBStandAloneSetPassword_title: "امنیت دو مرحله ای",
  AddRGBStandAloneSetPassword_text: "این رمز این دستگاه بوده و ارتباطی با رمز حساب کاربری شما ندارد. در حفظ این رمز کوشا باشید.",
  AddRGBStandAloneSetPassword_button: "ادامه",
  AddRGBStandAloneSetPassword_placeHolder: "رمز هاب",
  AddRGBStandAloneSetPassword_placeHolder2: "تکرار رمز هاب",
  AddRGBStandAloneSetPassword_alert_passwordEmpty: "لطفا برای این دستگاه یک رمز وارد نمایید.",
  AddRGBStandAloneSetPassword_alert_passwordNotMatch: "تکرار رمز با رمز همخوانی ندارد.",
  AddRGBStandAloneNameColor_title: "شخصی سازی دستگاه",
  AddRGBStandAloneNameColor_text: "لطفا نام و رنگ این دستگاه را انتخاب نمایید.",
  AddRGBStandAloneNameColor_placeHolder: "نام (خانه، دفتر ...)",
  AddRGBStandAloneNameColor_button: "ادامه",
  AddRGBStandAloneNameColor_alert_nameEmpty: "لطفا نام یا مکان استفاده از این دستگاه را وارد نمایید.",
  AddRGBStandAloneConnectWifi_title: "اتصال به دستگاه",
  AddRGBStandAloneConnectWifi_text: "لطفا به صفحه تنظیمات گوشی خود رفته و به شبکه Wi-Fi زیر متصل شوید. سپس به اپلیکیشن لکسا باز گشته و گزینه 'اتصال به دستگاه' را انتخاب نمایید.",
  AddRGBStandAloneConnectWifi_button: "اتصال به دستگاه",
  AddRGBStandAloneNotFound_title: "خطا در اتصال به دستگاه",
  AddRGBStandAloneNotFound_text: "متاسفانه اتصال به دستگاه موفقیت آمیز نبود. لطفا از اتصال خود به شبکه Wi-Fi دستگاه اطمینان حاصل کرده و مجددا تلاش کنید.",
  AddRGBStandAloneNotFound_button: "تلاش مجدد",
  AddRGBStandAloneNotFound_Cancel: "لغو",
  AddRGBStandAloneSuccess_title: "ثبت موفق",
  AddRGBStandAloneSuccess_text: "دستگاه لکسا شما با موفقیت ثبت شد. می توانید در صفحه 'دستگاه ها' این دستگاه را ببینید و تنظیمات آن را تغییر دهید.",
  AddRGBStandAloneSuccess_button: "تمام",
  Node9Settings_animation3: "میکروفون HSV",
  Node9Settings_animation4: "میکروفون Brightness",
  Node9Settings_animation5: "جک هدفون HSV",
  Node9Settings_animation6: "جک هدفون Brightness",
  Node2Settings_animationTypeDesc: "در صورت انتخاب میکروفون، برای جلوگیری از نویز وای فای روی صدا، تا روشن و خاموش کردن بعدی دستگاه، وای فای دستگاه خاموش می شود.",
  LuxinWidget_tvRemote: "ریموت تلویزیون",
  AddTvRemoteWidget_text1: "استایل ریموت",
  AddTvRemoteWidget_remoteStyle1: "کانال و صدا",
  AddTvRemoteWidget_remoteStyle2: "سورس و منو",
  // LuxinWidget_tvRemote: "ریموت تلویزیون",
  AddNewWidget_tvRemoteDescription: "یک ریموت کنترل برای کنترل تلویزیون با چند استایل",
  Node2Settings_default7: "هر دو کلید غیر فعال",
  Node2Settings_default8: "تنظیم تایمر حضور",
  OpenClose_text: "Normally Open / Normally Closed",
  NormalyOpen_text: "Normally Open",
  NormalyClosed_text: "Normally Closed",
  Folder_text: "فولدر",
  Root_text: "صفحه اصلی",
  LuxinWidget_folder: "فولدر",
  AddNewWidget_folderDescription: "یک فولدر برای دسته بندی ویجت های دیگر",
};
